import React, { useEffect } from "react";
import HeaderImage from "../../components/HeaderImage";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faVideo, faEnvelope } from "@fortawesome/free-solid-svg-icons";

const DiamonAccessFrenchPage: React.FC = () => {
  useEffect(() => {
    const element = document.getElementById("diamond");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  }, []);

  return (
    <>
      <HeaderImage image="/assets/images/backgrounds/diamond-fr.jpg" />

      <div className="max-w-4xl mx-auto mb-12 p-4" id="diamond">
        <section className="mb-4 mt-8">
          <h3 className="text-left text-sm font-medium mb-1">
            Rejoignez la communauté de pratique (CoP) sur la publication en libre
            accès sans frais en Afrique francophone
          </h3>

          <p className="text-sm text-foreground mb-2">
            WACREN, en partenariat avec Electronic Information for Libraries (EIFL)
            et African Journals Online (AJOL), a lancé une Communauté de Pratique
            francophone dans le cadre du projet{" "}
            <Link
              to="https://www.eifl.net/eifl-in-action/collaboration-sustainable-open-access-publishing-africa"
              target="_blank"
              className="text-primary"
            >
              Collaboration pour une Publication en Libre Accès Durable en Afrique
            </Link>
            , avec le soutien de <strong>Wellcome</strong>.
          </p>

          <p className="text-sm text-foreground mb-2">
            Cette Communauté de Pratique (CoP) a pour ambition de renforcer les
            capacités et de favoriser la collaboration entre les rédacteurs et
            éditeurs de revues ou de livres en libre accès sans frais (OA) en
            Afrique francophone, dans un contexte où le paysage mondial de
            l’édition académique évolue rapidement. La CoP s&apos;appuie sur les
            bases établies par le groupe de travail LIBSENSE.
          </p>

          <h4 className="text-left text-sm font-semibold text-foreground">
            Ce que permet la CoP&nbsp;:
          </h4>
          <ul className="text-sm text-foreground mb-4 list-disc pl-6">
            <li className="mb-2">
              le partage d’expériences, de ressources et de bonnes pratiques autour
              de l’édition en libre accès diamant&nbsp;;
            </li>
            <li className="mb-2">
              le développement de collaborations, partenariats et initiatives pour
              améliorer la qualité éditoriale&nbsp;;
            </li>
            <li className="mb-2">
              le soutien à des actions de plaidoyer en faveur de modèles OA
              durables et équitables.
            </li>
          </ul>

          <p className="text-sm text-foreground mb-2">
            Elle est ouverte à tous les rédacteurs et éditeurs affiliés à des
            organisations africaines publiant en libre accès sans frais, quels que
            soient leur expérience ou leur domaine disciplinaire.
          </p>

          <p className="text-sm text-foreground mb-2">
            Les échanges au sein de cette communauté visent à répondre directement
            aux défis mis en évidence par la récente étude sur la publication en
            libre accès sans frais en Afrique, qui a souligné la nécessité pour les
            acteurs africains&nbsp;:
          </p>

          <ul className="text-sm text-foreground mb-4 list-disc pl-6">
            <li className="mb-2">de rester au fait des tendances mondiales de l’édition&nbsp;;</li>
            <li className="mb-2">
              d&apos;avoir accès à des formations adaptées, à un soutien technique
              et à des ressources éditoriales&nbsp;;
            </li>
            <li className="mb-2">
              et de bénéficier d’un appui politique et financier pour faire vivre
              le modèle du libre accès diamant.
            </li>
          </ul>

          <h4 className="text-left text-sm font-semibold text-foreground mb-2">
            Comment nous rejoindre&nbsp;?
          </h4>
          <p className="text-sm text-foreground mb-4">
            Vous souhaitez apporter votre voix et participer à cette initiative qui
            œuvre pour une édition scientifique plus équitable et durable en
            Afrique&nbsp;? Remplissez simplement ce court questionnaire&nbsp;:{" "}
            <Link
              to="https://survey.wacren.net/index.php/567387"
              target="_blank"
              className="text-primary underline"
            >
              https://survey.wacren.net/index.php/567387
            </Link>{" "}
            <span className="text-muted-foreground">(2 minutes)</span>
          </p>

          {/* Canaux de la communauté */}
          <div className="text-center mt-6">
            <h4 className="text-xl font-semibold text-primary mb-6">
              Canaux de la communauté
            </h4>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Réunion mensuelle */}
              <Link
                to="https://wacren.zoom.us/meeting/register/u5IsdOGgrT0vG9UqJUXVCBB5UwxRnZsLk3-a"
                target="_blank"
                className="bg-card p-3 rounded-lg shadow-md transform transition-transform hover:scale-105 hover:shadow-lg hover:bg-transparent"
              >
                <div className="text-primary text-xxxxl mb-4">
                  <FontAwesomeIcon icon={faVideo} />
                </div>
                <h3 className="font-semibold text-lg text-card-foreground">
                  Réunion Zoom mensuelle
                </h3>
                {/* <p className="text-sm text-foreground mb-2">
                  Participez aux réunions mensuelles sur Zoom
                </p> */}
              </Link>

              {/* Liste de diffusion */}
              <div
                className="bg-card p-3 rounded-lg shadow-md transform transition-transform hover:scale-105 hover:shadow-lg hover:bg-transparent"
              >
                <div className="text-primary text-xxxxl mb-4">
                  <FontAwesomeIcon icon={faEnvelope} />
                </div>
                <h3 className="text-card-foreground font-semibold text-lg hover:text-foreground">
                  Forum de discussion (liste de diffusion)
                </h3>
                {/* <p className="text-sm text-foreground mb-2">
                  Rejoignez la liste pour échanger avec la communauté
                </p> */}
              </div>

              {/* Chat Server (optionnel) */}
              {/* <Link
                to="https://matrix.to/#/#diamond-oa-community:matrix.ren.africa"
                target="_blank"
                className="bg-card p-6 rounded-lg shadow-md transform transition-transform hover:scale-105 hover:shadow-lg hover:bg-blue-100"
              >
                <div className="text-primary text-xxxl mb-4">
                  <FontAwesomeIcon icon={faComments} />
                </div>
                <h3 className="font-semibold text-lg mb-2">Serveur de chat</h3>
                <p className="text-sm text-foreground mb-2">
                  Rejoignez notre chat communautaire
                </p>
              </Link> */}
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default DiamonAccessFrenchPage;
